import { ReactElement } from "react";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import BalanceRoundedIcon from "@mui/icons-material/BalanceRounded";
import CurrencyYenRoundedIcon from "@mui/icons-material/CurrencyYenRounded";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import PriceChangeRoundedIcon from "@mui/icons-material/PriceChangeRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";

import { dic } from "@common/text_defs";
import ProductDetailPage from "./components/ProductDetailPage";

const WorkPowerTradingPage = (): ReactElement => (
  <ProductDetailPage
    eyebrow="ENERGY TRADING & RISK MANAGEMENT"
    title={dic.works.prod_futsMS.title}
    description={dic.works.prod_futsMS.desc}
    summaryTitle="現物・先物取引を統合管理"
    summaryDescription="電力現物取引と先物などのデリバティブ取引を同じ基盤で管理。取引入力からポジション、時価評価、損益、決済までを正確かつ効率的につなぎます。"
    flowTitle="取引から決済までを一つの流れに"
    flow={[
      { label: "取引", detail: "現物・先物", icon: SwapHorizRoundedIcon },
      { label: "ポジション", detail: "数量・受渡期間", icon: BalanceRoundedIcon },
      { label: "評価・損益", detail: "時価・ヘッジ効果", icon: TrendingUpRoundedIcon },
      { label: "決済", detail: "精算・レポート", icon: GavelRoundedIcon },
    ]}
    capabilities={[
      { title: "取引管理", description: "電力の現物・先物取引を登録し、約定条件や受渡期間を一元管理します。", icon: SwapHorizRoundedIcon },
      { title: "ポジション管理", description: "商品・市場・期間別のポジションを集計し、売買と受渡の状況を可視化します。", icon: BalanceRoundedIcon },
      { title: "時価・損益管理", description: "市場価格をもとに評価損益と実現損益を算出し、取引成果を把握します。", icon: CurrencyYenRoundedIcon },
      { title: "価格・リスク分析", description: "価格変動とエクスポージャーを分析し、ヘッジ方針の検討を支援します。", icon: PriceChangeRoundedIcon },
      { title: "決済・精算", description: "取引条件と価格に基づく決済金額を管理し、精算業務へ確実につなげます。", icon: ReceiptLongRoundedIcon },
      { title: "レポート", description: "ポジション、損益、取引履歴を集計し、管理・確認に必要なレポートを出力します。", icon: AssessmentRoundedIcon },
    ]}
    valuesTitle="市場変動を捉え、リスクを管理"
    valuesDescription="現物とデリバティブを横断したポジションを可視化し、煩雑な集計作業を抑えながら、迅速な取引判断と正確な管理を支援します。"
    values={[
      { title: "ポジションを可視化", description: "現物・先物を横断し、期間別の保有状況を把握" },
      { title: "損益を正確に管理", description: "取引から評価・実現損益まで一貫して計算" },
      { title: "ヘッジ判断を支援", description: "価格変動リスクとヘッジ効果を同じ画面で確認" },
    ]}
    contactTitle="電力取引・リスク管理業務に合わせてご提案します"
    colors={{ dark: "#29334f", darkAlt: "#525d7d", primary: "#c7d5ff", pale: "#edf0f8", accent: "#e8bd62", text: "#252f47" }}
  />
);

export default WorkPowerTradingPage;
